<template>
  <base-container>
    <ArtisanGrid
      ref="rule"
      metaKey="ManagerRule"
      :query="query"
      :metaInited="metaInited"
      :confirmBefore="confirmBefore"
      :handleData="handleData"
    >
      <template #valueForm="{ row }">
        <div v-if="row.code == 'undo'">
          爽约<el-input-number
            class="margin-h5"
            :min="1"
            v-model="row.undoCount"
          ></el-input-number>
          次,将限制预约<el-input-number
            :min="1"
            class="margin-h5"
            v-model="row.limitDayCount"
          ></el-input-number
          >天
        </div>
        <div v-else>请选择规则类型</div>
      </template>
      <template #value="{ row }">
        <div v-if="row.code == 'undo'">
          爽约<b class="color-danger">{{ row.undoCount }}</b
          >次,将限制预约<b class="color-danger">{{ row.limitDayCount }}</b
          >天
        </div>
        <div v-else>请选择规则类型</div>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
export default {
  props: ["query"],
  data() {
    return {};
  },
  methods: {
    metaInited(option) {
      option.columns.find((c) => c.code == "value").isSlot = true;
    },
    handleValue(row) {
      if (row.undoCount && row.limitDayCount) {
        row.value = JSON.stringify({
          undoCount: row.undoCount,
          limitDayCount: row.limitDayCount,
        });
      }
    },
    confirmBefore(dialog, row) {
      if (row.undoCount && row.limitDayCount) {
        row.value = JSON.stringify({
          undoCount: row.undoCount,
          limitDayCount: row.limitDayCount,
        });
        return true;
      } else {
        this.$message({
          type: "error",
          message: "请输入正确的规则内容！",
        });
        return false;
      }
    },
    handleData(data) {
      data.forEach((item) => {
        var obj = JSON.parse(item.value);
        Object.assign(item, obj);
      });
    },
  },
};
</script>

<style>
</style>